module.exports = __webpack_public_path__ + "static/media/bankruptcy.e8d4c134.svg";